<p-fileUpload
    #fileUploadInput
    name="{{ name }}"
    [accept]="control.accept"
    [chooseIcon]="control.chooseIcon ?? ''"
    [chooseLabel]="control.chooseLabel ?? ''"
    [cancelIcon]="control.cancelIcon ?? ''"
    [cancelLabel]="control.cancelLabel ?? ''"
    [cancelStyleClass]="control.cancelStyleClass ?? ''"
    [chooseStyleClass]="control.chooseStyleClass ?? ''"
    [fileLimit]="control.fileLimit"
    [files]="control.files || []"
    [maxFileSize]="control.maxFileSize"
    [mode]="control.mode"
    [multiple]="control.multiple"
    [removeStyleClass]="control.removeStyleClass ?? ''"
    [showCancelButton]="control.showCancelButton"
    [showUploadButton]="control.showUploadButton"
    [styleClass]="control.styleClass ?? ''"
    [uploadIcon]="control.uploadIcon ?? ''"
    [uploadLabel]="control.uploadLabel ?? ''"
    [uploadStyleClass]="control.uploadStyleClass ?? ''"
    (onClear)="onClear()"
    (onRemove)="onRemove($event)"
    (onSelect)="onSelect($event)"
>
</p-fileUpload>
<input type="hidden" [formControl]="control" id="{{ 'h-upd' + name }}" />
